var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "tw-flex tw-flex-col tw-pl-6 tw-pt-20 league-table-container tw-h-full"
    },
    [
      _c(
        "v-row",
        { staticClass: "tw-flex-grow-0 tw-mb-6" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "12", lg: "4" } },
            [
              _c("MOTMTable", {
                key: _vm.selectedMatch.id,
                attrs: {
                  selectedManOfTheMatch: _vm.selectedMatch,
                  type: "man_of_match"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }